import axios from "axios";

/**
 * Generic GraphQL caller using Axios
 * @param {string} query - The GraphQL query string
 * @param {object} variables - Optional variables
 * @returns {Promise<object>} - Returns the data or throws error
 */

const endpoint =
  "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/luckify-game/api"; //mainnet endpoint


const endpointCrashGame =
  "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/luckify-game/api"; //temprory graph

export const callGraphQLQuery = async (query, variables = {}) => {
  try {
    const response = await axios.post(
      endpoint,
      {
        query,
        variables,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.errors) {
      console.error("GraphQL Errors:", response.data.errors);
      throw new Error("GraphQL returned errors");
    }

    return response.data.data;
  } catch (error) {
    console.error("GraphQL Request Failed:", error);
    throw error;
  }
};

export const callCrashGameGraphQLQuery = async (query, variables = {}) => {
  try {
    const response = await axios.post(
      endpointCrashGame,
      {
        query,
        variables,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.errors) {
      throw new Error("GraphQL returned errors");
    }
    // console.log(response.data.data, "response.data.data");
    return response.data.data;
  } catch (error) {
    console.error("GraphQL Request Failed:", error);
    throw error;
  }
};
